import React, { useEffect } from 'react';

const WingoWiki: React.FC = () => {
  useEffect(() => {
    // Set page title
    document.title = 'WINGO - Wingipedia';
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'WINGO is the cryptocurrency and economic unit of WINGO World, earned through running performance and community participation.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Full-width header section */}
      <div className="w-full bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-4 lg:ml-36">
        {/* Mobile header and intro - appears first on mobile */}
        <div className="lg:hidden mb-6">
          {/* Wikipedia-style header */}
          <div className="border-b border-gray-200 pb-2 mb-4">
              <h1 className="text-3xl sm:text-4xl font-semibold mb-2 border-b border-gray-300 pb-1" style={{ fontFamily: 'Hoefler Text, Garamond, Times New Roman, serif', letterSpacing: '-0.02em' }}>
                WINGO
            </h1>
              <p className="text-sm text-gray-600 italic mb-2">From Wingipedia, the WINGO World encyclopedia</p>
          </div>

          {/* Lead section */}
          <div className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
            <p className="text-base mb-3">
                <strong>WINGO</strong> (Workout Independence Network Gains Optimization) is the cryptocurrency and primary economic unit of WINGO World, earned through running performance, community participation, and wager outcomes. The currency operates on a performance-based earning model where participants accumulate WINGO through completing 320-meter <a href="/wingipedia/wingo-unit" className="text-blue-600 hover:underline">Wingos</a> at the <a href="/wingipedia/wingate" className="text-blue-600 hover:underline">Historic Wingate Track</a>.
              </p>
            </div>
          </div>

        {/* Desktop header and intro */}
        <div className="hidden lg:block mb-6">
          {/* Wikipedia-style header */}
          <div className="border-b border-gray-200 pb-2 mb-4">
            <h1 className="text-3xl sm:text-4xl font-semibold mb-2 border-b border-gray-300 pb-1" style={{ fontFamily: 'Hoefler Text, Garamond, Times New Roman, serif', letterSpacing: '-0.02em' }}>
              WINGO
            </h1>
            <p className="text-sm text-gray-600 italic mb-2">From Wingipedia, the free encyclopedia</p>
          </div>

          {/* Desktop bio image - positioned to float right */}
          <div className="hidden lg:block float-right ml-6 mb-6 w-80" style={{ fontFamily: 'Georgia, serif' }}>
            <div className="bg-white border border-gray-300 p-3 text-xs" style={{ fontSize: '11px', lineHeight: '1.3' }}>
              <div className="text-center mb-2">
                <span className="font-bold" style={{ fontSize: '14px' }}>WINGO</span>
              </div>
              
                <div className="text-center mb-2">
                  <img 
                    src="/wingo_price_chart.png" 
                    alt="WINGO price chart" 
                    className="w-full h-32 object-cover rounded"
                    style={{ objectPosition: 'center' }}
                  />
                </div>
              
              <div className="space-y-0.5">
                <div>
                  <span className="font-bold" style={{ fontSize: '10px' }}>Type:</span>
                  <span className="ml-1" style={{ fontSize: '10px' }}>Cryptocurrency</span>
                </div>
                <div>
                  <span className="font-bold" style={{ fontSize: '10px' }}>Platform:</span>
                  <span className="ml-1" style={{ fontSize: '10px' }}>WINGO World</span>
                </div>
          
                <div>
                  <span className="font-bold" style={{ fontSize: '10px' }}>Earning:</span>
                  <span className="ml-1" style={{ fontSize: '10px' }}>Performance-based</span>
                </div>
                <div>
                  <span className="font-bold" style={{ fontSize: '10px' }}>Governance:</span>
                  <span className="ml-1" style={{ fontSize: '10px' }}>320 Track Club</span>
                </div>
                <div>
                  <span className="font-bold" style={{ fontSize: '10px' }}>Ledger:</span>
                  <span className="ml-1" style={{ fontSize: '10px' }}>Coach DAISY™</span>
                </div>
              </div>
            </div>
          </div>

          {/* Lead section */}
          <div className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
            <p className="text-base mb-3">
              <strong>WINGO</strong> (Workout Independence Network Gains Optimization) is the cryptocurrency and primary economic unit of <a href="/wingipedia/wingo-world" className="text-blue-600 hover:underline">WINGO World</a>, earned through running performance, community participation, and wager outcomes. The currency operates on a performance-based earning model where participants accumulate WINGO through completing 320-meter <a href="/wingipedia/wingo-unit" className="text-blue-600 hover:underline">Wingos</a> at the <a href="/wingipedia/wingate" className="text-blue-600 hover:underline">Historic Wingate Track</a>.
            </p>
          </div>

        </div>
        </div>
      </div>

      {/* Frozen Contents - Desktop only */}
      <div className="hidden lg:block fixed top-36 left-4 w-44 z-10">
        <div className="bg-white p-3" style={{ fontFamily: 'Georgia, serif' }}>
              <div className="flex justify-between items-center mb-2">
                <h2 className="text-sm font-bold">Contents</h2>
                <button className="text-xs text-blue-600 hover:underline">[hide]</button>
              </div>
              <ol className="list-decimal list-inside space-y-0.5 text-xs">
                <li><a href="#overview" className="text-blue-600 hover:underline">Overview</a></li>
                <li><a href="#usage" className="text-blue-600 hover:underline">Usage and applications</a></li>
                <li><a href="#see-also" className="text-blue-600 hover:underline">See also</a></li>
              </ol>
            </div>
          </div>

      {/* Main content area with proper positioning */}
      <div className="w-full py-1">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 lg:ml-36">
          {/* Main content - sections that wrap around bio image */}
          <div className="lg:mr-0">

            {/* Mobile bio image - appears after table of contents */}
            <div className="block lg:hidden mb-6">
              <div className="bg-white border border-gray-300 p-3 text-xs" style={{ fontSize: '11px', lineHeight: '1.3' }}>
                <div className="text-center mb-2">
                  <span className="font-bold" style={{ fontSize: '14px' }}>WINGO</span>
                </div>
                
                <div className="text-center mb-2">
                  <img 
                    src="/wingo_price_chart.png" 
                    alt="WINGO price chart" 
                    className="w-full h-32 object-cover rounded"
                    style={{ objectPosition: 'center' }}
                  />
                </div>
                
                <div className="space-y-0.5">
                  <div>
                    <span className="font-bold" style={{ fontSize: '10px' }}>Type:</span>
                    <span className="ml-1" style={{ fontSize: '10px' }}>Cryptocurrency</span>
                  </div>
                  <div>
                    <span className="font-bold" style={{ fontSize: '10px' }}>Platform:</span>
                    <span className="ml-1" style={{ fontSize: '10px' }}>WINGO World</span>
                  </div>
            
                  <div>
                    <span className="font-bold" style={{ fontSize: '10px' }}>Earning:</span>
                    <span className="ml-1" style={{ fontSize: '10px' }}>Performance-based</span>
                  </div>
                  <div>
                    <span className="font-bold" style={{ fontSize: '10px' }}>Governance:</span>
                    <span className="ml-1" style={{ fontSize: '10px' }}>320 Track Club</span>
                  </div>
                  <div>
                    <span className="font-bold" style={{ fontSize: '10px' }}>Ledger:</span>
                    <span className="ml-1" style={{ fontSize: '10px' }}>Coach DAISY™</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Overview section */}
            <section id="overview" className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
              <h2 className="text-2xl font-medium mb-3 border-b border-gray-300 pb-1" style={{ fontFamily: 'Georgia, serif' }}>
                <span className="block w-full lg:inline lg:max-w-[calc(100%-350px)]">Overview</span>
              </h2>
              
              <p className="mb-3 text-base">
                WINGO serves as both a reward mechanism and a medium of exchange within the WINGO World ecosystem. Unlike traditional cryptocurrencies that rely on mining or staking, WINGO is earned through physical performance and community participation, creating a unique intersection between athletic achievement and economic activity.
              </p>
              
              <p className="mb-3 text-base">
                The currency is managed by <a href="/wingipedia/daisy" className="text-blue-600 hover:underline">Coach DAISY™</a>, who maintains the official ledger and oversees all transactions. This centralized management, combined with decentralized community governance, creates a hybrid economic model that balances efficiency with community control.
              </p>

              <p className="mb-3 text-base">
                The currency "WINGO" is distinct from <a href="/wingipedia/wingo-unit" className="text-blue-600 hover:underline">Wingo</a>, the 320-meter track unit. While "WINGO" (always singular) refers to the cryptocurrency, "Wingos" (plural) refer to track distances.
              </p>

            </section>


            {/* Usage and applications section */}
            <section id="usage" className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
              <h2 className="text-2xl font-medium mb-3 border-b border-gray-300 pb-1" style={{ fontFamily: 'Georgia, serif' }}>Usage and applications</h2>
              
              
              <p className="mb-3 text-base">
                WINGO serves as the primary currency for community activities, including <a href="/wager" className="text-blue-600 hover:underline">wager participation</a> and <a href="https://www.daisy320.com/merch" className="text-blue-600 hover:underline">merchandise purchases</a>. The currency supports both individual and community needs within the WINGO World ecosystem.
              </p>
            </section>


            {/* See also */}
            <section id="see-also" className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
              <h2 className="text-2xl font-medium mb-3 border-b border-gray-300 pb-1" style={{ fontFamily: 'Georgia, serif' }}>See also</h2>
              <ul className="list-disc list-inside space-y-1 text-base">
                <li><a href="/wingipedia/daisy" className="text-blue-600 hover:underline">Coach DAISY™</a></li>
                <li><a href="/wingipedia/wingate" className="text-blue-600 hover:underline">Historic Wingate Track</a></li>
                <li><a href="/wingipedia/wingo-unit" className="text-blue-600 hover:underline">Wingo</a></li>
              </ul>
            </section>
              </div>
        </div>
      </div>
    </div>
  );
};

export default WingoWiki;
